"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var isScrollingDown_1 = require("../helpers/isScrollingDown");
var Menu_1 = __importDefault(require("./Menu"));
var StickyHeader = /** @class */ (function () {
    function StickyHeader() {
        this.stickyHeader = document.querySelector("[".concat(constants_1.DATA_STICKY_HEADER, "]"));
        if (!this.stickyHeader) {
            return;
        }
        StickyHeader.header = this.stickyHeader;
        this.HEADER_STICKY_OFFSET = Math.round(window.innerHeight * (1 / 3));
        this.nav = this.stickyHeader.querySelector('nav');
        this.initEventListeners();
    }
    StickyHeader.prototype.initEventListeners = function () {
        var _this = this;
        document.addEventListener('scroll', function () {
            _this.documentScroll(_this.HEADER_STICKY_OFFSET);
        });
    };
    StickyHeader.prototype.documentScroll = function (offset) {
        if (!(0, isScrollingDown_1.isScrollingDown)() && document.documentElement.scrollTop > offset) {
            this.isSticky();
            return;
        }
        this.isNotSticky();
    };
    StickyHeader.prototype.isSticky = function () {
        if (!this.stickyHeader.classList.contains(constantsClasses_1.CLASS_STICKY)) {
            this.stickyHeader.classList.add(constantsClasses_1.CLASS_STICKY);
        }
        if (!this.nav.classList.contains(constantsClasses_1.CLASS_STICKY)) {
            this.nav.classList.add(constantsClasses_1.CLASS_STICKY);
        }
    };
    StickyHeader.prototype.isNotSticky = function () {
        if (Menu_1.default.isOpen) {
            return;
        }
        if (this.stickyHeader.classList.contains(constantsClasses_1.CLASS_STICKY)) {
            this.stickyHeader.classList.remove(constantsClasses_1.CLASS_STICKY);
        }
        if (this.nav.classList.contains(constantsClasses_1.CLASS_STICKY)) {
            this.nav.classList.remove(constantsClasses_1.CLASS_STICKY);
        }
    };
    return StickyHeader;
}());
exports.default = StickyHeader;
